import { Colors, Theme } from '@user-portal/wikr-components';
import React from 'react';
import { useTheme } from 'styled-components';

const Calendar = ({ color, size = 24 }: { color?: Colors; size?: number }) => {
    const theme = useTheme() as Theme;
    const iconColor = theme[color || 'border-default'];

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none">
            <path
                fill={iconColor}
                d="M21.44 8H2.06A4.76 4.76 0 0 1 6 4.08V2.75a.75.75 0 0 1 1.5 0V4H16V2.75a.75.75 0 1 1 1.5 0v1.33A4.76 4.76 0 0 1 21.44 8M2 9.5v7.25a4.75 4.75 0 0 0 4.75 4.75h10a4.75 4.75 0 0 0 4.75-4.75V9.5zm13.28 3.78-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.47-3.47a.75.75 0 0 1 1.06 1.06"
            />
        </svg>
    );
};

export default Calendar;
